import React, { useState } from "react";
// import JobSwmsFormContainer from "./JobSwmsForm/JobSwmsFormContainer";
import JobSwmsFormV3Container from "./JobSwmsForm/v3/JobSwmsFormV3Container.jsx";
import JobSwmsV2 from "./JobSwmsTask/JobSwmsV2";
import PreviewV3Container from "./JobSwmsPreview/v3/PreviewV3Container";
import styles from "../JobStyle.module.css";

export default function JobSwmsContainer(props) {

  const [showForm, setShowForm] = useState(false);
  const [selectedSwms, setSelectedSwms] = useState(null);
  const [previewSwms, setPreviewSwms] = useState(null);
  const [sections, setSections] = useState(["0"]);

  const toggleForm = (swms) => {
    setSelectedSwms(swms);
    setShowForm(!showForm);
  }

  return (
    <div className={styles.TabContainer}>
      <div className="job-swms-container">
        {showForm ? (
          <JobSwmsFormV3Container
            jobId={props.jobId}
            swms={selectedSwms}
            onPreview={setPreviewSwms}
            onClose={toggleForm}
          />
        ) : (
          <JobSwmsV2
            jobId={props.jobId}
            sections={sections}
            setSections={setSections}
            goToForm={toggleForm} />
        )}
        {previewSwms ? (
          <PreviewV3Container
            previewJobId={props.jobId}
            swms={previewSwms}
            onClose={() => setPreviewSwms(null)}
          />
        ) : null}
      </div>
    </div>
  )
}